<template>
  <div class="work__next">
    <span class="ff-mono fs-12 tt-u sp-12">Next Project</span>
    <NuxtLink class="work__next__link" :to="`/works/${nextProject?.work?.uid}`">
      <ClientOnly>
        <AppLink
          class="ta-r"
          :class="{ 'fs-24': !$mq.isMobile, 'fs-48': $mq.isMobile }"
          :underline="true"
        >
          {{ nextProject?.work?.data?.name }}
        </AppLink>
      </ClientOnly>
    </NuxtLink>
  </div>
</template>

<script setup>
const { $Lenis, $mq } = useNuxtApp();
const progress = ref(0);

const props = defineProps({
  nextProject: { type: Object, default: null },
});

onMounted(() => {
  $Lenis.core.on('scroll', e => {
    progress.value = Math.floor(e.progress * 100);
  });
});
</script>

<style lang="scss" scoped>
.work__next {
  padding: var(--offset);
  display: flex;
  flex-direction: column;
  margin-top: fluidMap($spacing, 120);
  margin-bottom: fluidMap($spacing, 120);
  position: relative;
  width: fit-content;
}
</style>
